/* eslint-disable no-underscore-dangle */
const { debug } = window._webpack_init_props;
delete window._webpack_init_props.debug;

window.BINGADS_DEBUG = debug;
